module.exports = __webpack_public_path__ + "static/media/vsali.1414f236.png";